import script from "./attention.vue?vue&type=script&setup=true&lang=js"
export * from "./attention.vue?vue&type=script&setup=true&lang=js"

import "./attention.vue?vue&type=style&index=0&id=3abc8007&lang=scss"

const __exports__ = script;

export default __exports__